export default __webpack_public_path__ + "static/media/Yes sir. .673f68f6.mp3";